export * from './lib/ui-core.module';
export * from './lib/angular-material/material.module';

export * from './lib/components/bodyanalytics-base/bodyanalytics-base.component';
export * from './lib/enums/content.enum';
export * from './lib/enums/http-header.enum';
export * from './lib/enums/admin-auth-storage-keys.enum';

export * from './lib/enums/google-analytics-enum';
export * from './lib/enums/api-routes.enum';
export * from './lib/enums/router-urls.enum';
export * from './lib/enums/test-session-steps.enum';
export * from './lib/enums/product.enum';
export * from './lib/enums/dialog.enum';
export * from './lib/components/default-empty-data-container/default-empty-data-container.component';
export * from './lib/components/page-not-found/page-not-found.component';
export * from './lib/components/service-maintenance/service-maintenance.component';
export * from './lib/maintenance/with-maintenance-mode';
export * from './lib/components/server-error/server-error.component';
export * from './lib/components/dialogs';
export * from './lib/components/access-denied/access-denied.component';
export * from './lib/components/alert/alert.component';
export * from './lib/components/load-error/load-error.component';
export * from './lib/components/empty-state/empty-state.component';
export * from './lib/components/generic-form/generic-form.component';
export * from './lib/components/step-indicator/step-indicator.component';
export * from './lib/shared-components/loading-spinner/loading-spinner.component';
export * from './lib/shared-components/brand-logo/brand-logo.component';
export * from './lib/shared-components/app-splash/app-splash.component';

export * from './lib/shell/header/header.component';
export * from './lib/shell/footer/footer.component';
export * from './lib/shell/slim-footer/slim-footer.component';
export * from './lib/shell/profile-menu/profile-menu.component';
export * from './lib/shell/admin-shell/admin-shell.component';
export * from './lib/shell/admin-shell/mobile-tab-bar/mobile-tab-bar.component';
export * from './lib/mock-data/data';
export * from './lib/services/navigation-hub/navigation-hub.service';

export * from './lib/services/interceptor/interceptor.service';
export * from './lib/services/interceptor/tenantInterceptor.service';
export * from './lib/services/interceptor/http-error.interceptor';
export * from './lib/services/interceptor/ng-zone-reentry.interceptor';
export * from './lib/services/error/global-error-handler';
export * from './lib/services/error/sentry-error-reporting';

export * from './lib/services/branding/branding.service';
export * from './lib/services/tenant-slug/tenant-slug.service';

export * from './lib/services/session-storage/session-storage';
export * from './lib/services/session-storage/session-storage.service';
export * from './lib/components/modal/modal.component';
export * from './lib/services/modal/modal.service';
export * from './lib/components/toast-container/toast-container.component';
export * from './lib/services/toast/toast.service';
export * from './lib/services/error/error.service';
export * from './lib/services/log/log.service';
export * from './lib/services/timer/timer.service';
export * from './lib/services/time-format/time-format.service';
export * from './lib/services/masking/masking.service';
export * from './lib/validators/validators';
export * from './lib/auth/auth-permissions.guard';
export * from './lib/services/auth/jwt-auth.service';
export * from './lib/services/auth/admin-auth.service';
export * from './lib/services/auth/customer-identity.service';
export * from './lib/guards/admin-role.guard';
export * from './lib/guards/customer-identity.guard';
export * from './lib/services/encryption/secure-storage.service';
export * from './lib/interfaces/secure-admin-tenant-info.interface';

export * from './lib/+http/base-http-crud.service';
export * from './lib/+store/with-entities-store';
export * from './lib/+store/with-local-storage';

export * from './lib/services/lookup-data/lookup-data.service';

export * from './lib/helper/blob-download';
export * from './lib/helper/helper';
export * from './lib/helper/user-display';
export * from './lib/helper/session';
export * from './lib/helper/safe-error-summary';
export * from './lib/pipes/phone.pipe';
export * from './lib/pipes/central-date.pipe';
export * from './lib/pipes/central-time.pipe';

// Analytics Service
export * from './lib/services/analytics/analytics.service';
export * from './lib/services/analytics/analytics.models';
export * from './lib/services/analytics/analytics.constants';

// A11y directives — #816
export * from './lib/a11y';

// Phone-number mask directive — #1287 (dashed 555-123-4567 + FormControl sync)
export * from './lib/directives/phone-number.directive';

// Form primitives — R-FORM-01..07 (DESIGN.md May 2026)
export * from './lib/components/forms/eyebrow/eyebrow.component';
export * from './lib/components/forms/field-label/field-label.component';
export * from './lib/components/forms/field-input/field-input.component';
export * from './lib/components/forms/field-select/field-select.component';
export * from './lib/components/forms/field-toggle/field-toggle.component';
export * from './lib/components/forms/section-rule/section-rule.component';
export * from './lib/components/forms/edit-section/edit-section.component';
export * from './lib/components/forms/view-section/view-section.component';
export * from './lib/components/forms/adm-data-point/adm-data-point.component';
export * from './lib/components/adm-detail-hero/adm-detail-hero.component';
export * from './lib/components/adm-danger-zone/adm-danger-zone.component';

// Form/nav primitives — #1142 (unblocks #1156 + the assessment wizard)
export * from './lib/components/primitives/combobox/combobox.component';
export * from './lib/components/primitives/stepper/stepper.component';
export * from './lib/components/primitives/tab-bar/tab-bar.component';

// StatusPill — promoted from manage-events/ui to ui-core (#1142)
export * from './lib/components/status-pill/status-pill.component';

// Light/dark theme — shared service + toggle wired into every portal shell
export * from './lib/theme/theme.service';
export * from './lib/theme/dark-mode-toggle.component';
